export default __webpack_public_path__ + "static/media/banner.58072744.jpg";